import colors from "../../Constants/colors";
import { inputStyles } from "../../Constants/inputStyles";
import theme, { scrollbarStyles } from "../../Constants/theme";

export const loginContainer = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  width: "100%",
  backgroundColor: theme.backgroundColors.dark.primary,
  padding: 0,
};
export const loginPaper = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  color: theme.main.extremeWhite,
  borderRadius: theme.borderRadius.sm,
  padding: {
    xs: "1.5rem 1rem", // for extra-small devices
    sm: "2rem 1.5rem", // for small devices
    md: "2.5rem 2rem", // for medium devices
    lg: "3rem 2.5rem", // for large devices
  },
  width: {
    xs: "90%",
    sm: "70%",
    md: "60%",
    lg: "60%",
    xl: "60%",
  },
  minHeight: {
    xs: "auto",
    sm: "auto",
    md: "74%",
  },
  margin: "auto",
};
export const loginButtonLayout = {
  backgroundColor: theme.main.primaryBlue,
  color: theme.main.extremeWhite,
  width: "150px",
  "&:hover": {
    backgroundColor: theme.main.tertiaryBlue,
  },
  margin: "1rem",
  boxShadow: `0px 0px 10px ${theme.main.secondaryBlue}`,
};
export const verificationButtonLayout = {
  backgroundColor: "var(--primaryBlue)",
  color: "var(--extremeWhite)",
  width: "auto",
  "&:hover": {
    backgroundColor: "var(--tertiaryBlue)",
  },
  margin: "1rem",
  boxShadow: "0px 0px 10px var(--secondaryBlue)",
};

export const underlineLink = {
  color: "var(--extremeWhite)",
  borderBottom: "1px solid var(--extremeWhite)",
  cursor: "pointer",
  "&:hover": {
    color: "var(--primaryBlue)",
    borderBottom: "1px solid var(--primaryBlue)",
  },
};

export const TypographyLayout = {
  color: theme.textColors.dark.primary,
  textAlign: "center",
};

//version 1
export const textFieldLayout = {
  backgroundColor: theme.main.extremeWhite,
  color: theme.main.extremeBlack,
  borderRadius: theme.borderRadius.sm,
  border: `1px solid ${theme.main.primaryBlue}`,

  width: {
    xs: "90%",
    sm: "85%",
    md: "80%",
    lg: "70%",
  },

  m: {
    xs: 1,
    sm: 1.5,
    md: 2,
  },

  // Input styling
  "& .MuiInputBase-input": {
    color: theme.main.extremeBlack,
    fontSize: {
      xs: "0.875rem",
      sm: "0.925rem",
      md: "1rem",
    },
    padding: {
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
    },
  },

  "& .MuiInputLabel-root.Mui-focused": {
    fontSize: {
      xs: "1rem",
      sm: "1.125rem",
      md: "1.25rem",
    },
    color: theme.main.extremeBlack,
    transform: {
      xs: "translate(14px, 0px) scale(0.75)",
      sm: "translate(14px, 0px) scale(0.75)",
      md: "translate(14px, 0px) scale(0.75)",
    },
  },

  "& .MuiInputLabel-root": {
    color: theme.main.extremeBlack,
    fontSize: {
      xs: "0.875rem",
      sm: "0.925rem",
      md: "1rem",
    },
  },

  "&:hover": {
    borderColor: theme.main.secondaryBlue,
  },

  "&:focus-within": {
    borderColor: colors.primaryBlue,
    boxShadow: `0 0 0 2px ${colors.primaryBlue}25`,
  },

  transition: "all 0.2s ease-in-out",

  maxWidth: "500px",
};

export const TitleTypographyLayout = {
  fontWeight: 600,
  color: theme.textColors.dark.primary,
  marginBottom: "1rem",
  textAlign: "center",
};

// form on your secondary‐dark background
export const formPanel = {
  flex: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // bgcolor: "#0F172A",
  background: "linear-gradient(180deg, #1E1B3B 0%, #08071c 100%)",
  maxHeight: "100vh",
  overflowY: "auto",
  ...scrollbarStyles,
};

// illustration on your primary‐dark background
export const artPanel = {
  flex: 1,
  bgcolor: theme.main.secondaryBlue,
  // if you have an SVG or image asset:
  backgroundImage: 'url("/assets/illustration.svg")',
  backgroundSize: "cover",
  backgroundPosition: "center",
  // hide on small screens
  display: { xs: "none", md: "block" },
};

export const fieldProps = {
  variant: "outlined",
  margin: "dense",
  fullWidth: true,
  sx: {
    ...inputStyles.textField,
    width: "100%",
    mt: 0.5,
    maxWidth: "600px",
    boxSizing: "border-box",
  },
  // InputLabelProps: { shrink: true },
};
